// revert-LSW-157
// Dependencies
import React from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// hooks
import useContentDynamic from '../hooks/useContentDynamic';
import useLogin from '../hooks/useLogin';
import useLanguage from '../hooks/useLanguage';

// images
import schedulingBlack from '../../sass/images/icons/scheduling_icon_black.svg';
import schedulingWhite from '../../sass/images/icons/scheduling_icon_white.svg';
import historicalBlack from '../../sass/images/icons/icono-historial-black.svg';
import historicalWhite from '../../sass/images/icons/icono-historial-white.svg';
import closeBlack from '../../sass/images/icons/icon_exit_black.svg';
import closeWhite from '../../sass/images/icons/icon_exit_white.svg';
import alertMenu from '../../sass/images/icons/alert-menu.svg';
import userBlack from '../../sass/images/icons/user_black.svg';
import userWhite from '../../sass/images/icons/user_white.svg';
import inventoryWhite from '../../sass/images/icons/inventory_white.svg';
import inventoryBlack from '../../sass/images/icons/inventory_black.svg';


function MenuContentWorkShop(props) {
  const { t, children, newMaintenances } = props;
  const { locale } = useLanguage();
  const { expandedMenu, location, history, selectedNav, setSelect, setExpanded } =
    useContentDynamic();
  const { rolId, logout } = useLogin({});

  return (
    <div className="col-12">
      <SideNav
        expanded={expandedMenu}
        onToggle={(expanded) => {
          setExpanded(expanded);
        }}
        onSelect={(selected) => {
          const to = `/${locale}/${selected}`;
          if (location.pathname !== to) {
            setSelect(selected);
            history.push(to);
          }
        }}
      >
        <SideNav.Toggle />
        <SideNav.Nav defaultSelected={selectedNav}>
          <NavItem eventKey={t('routers:MaintenanceSchedule')}>
            <NavIcon>
              <img
                className={newMaintenances > 0 ? 'icon' : ''}
                src={
                  selectedNav === `${t('routers:MaintenanceSchedule')}`
                    ? schedulingWhite
                    : schedulingBlack
                }
                alt={t('alt:maintenance_schedule')}
              />
              {newMaintenances > 0 ? (
                <img className="img-alert-menu" src={alertMenu} alt={t('alt:notification')} />
              ) : (
                ''
              )}
            </NavIcon>
            <NavText>{t('maintenance-schedule')}</NavText>
          </NavItem>
          <NavItem eventKey={t('routers:MaintenanceHistory')}>
            <NavIcon>
              <img
                className={newMaintenances > 0 ? 'icon2' : ''}
                src={
                  selectedNav === `${t('routers:MaintenanceHistory')}`
                    ? historicalWhite
                    : historicalBlack
                }
                alt={t('alt:maintenance_history')}
              />
            </NavIcon>
            <NavText>{t('maintenance-history')}</NavText>
          </NavItem>
          {rolId === 4 ? (
            <NavItem eventKey={t('routers:UserRegistrationWorkShop')}>
              <NavIcon>
                <img
                  className='icon-user-custom'
                  src={
                    selectedNav === `${t('routers:UserRegistrationWorkShop')}`
                      ? userWhite
                      : userBlack
                  }
                  alt={t('alt:user_registration')}
                />
              </NavIcon>
              <NavText>{t('userRegistrationWorkShop')}</NavText>
            </NavItem>
          ) : (
            ''
          )}
          <NavItem eventKey={t('routers:StockStorage')}>
            <NavIcon>
              <img
                src={
                  selectedNav === `${t('routers:StockStorage')}`
                    ? inventoryWhite
                    : inventoryBlack
                }
                alt={t('alt:storage')}
              />
            </NavIcon>
            <NavText>{t('stockStorage')}</NavText>
          </NavItem>
          <NavItem eventKey="" className="close_sesion" onClick={logout}>
            <NavIcon>
              <img src={selectedNav === '' ? closeWhite : closeBlack} alt={t('alt:logout')} />
            </NavIcon>
            <NavText>{t('logout')}</NavText>
          </NavItem>
        </SideNav.Nav>
      </SideNav>
      <div className={`content_dashboard ${expandedMenu ? 'show-content' : 'hide-content'}`}>
        {children}
      </div>
    </div>
  );
}

MenuContentWorkShop.propTypes = {
  t: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  newMaintenances: PropTypes.number,
};
MenuContentWorkShop.defaultProps = {
  newMaintenances: 0,
};

export default withTranslation(['privateMenu', 'routers', 'alt'])(MenuContentWorkShop);
